import React from "react"

export const GoogleAnalyticsIcon = ({ height = 16, width = 16, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.833 2.41669V13.4167C10.833 14.6475 11.6822 15.3334 12.583 15.3334C13.4163 15.3334 14.333 14.75 14.333 13.4167V2.50002C14.333 1.37169 13.4997 0.666687 12.583 0.666687C11.6663 0.666687 10.833 1.44419 10.833 2.41669Z"
        fill="currentColor"
      />
      <path
        d="M6.25 8V13.4167C6.25 14.6475 7.09917 15.3333 8 15.3333C8.83333 15.3333 9.75 14.75 9.75 13.4167V8.08333C9.75 6.955 8.91667 6.25 8 6.25C7.08333 6.25 6.25 7.0275 6.25 8Z"
        fill="currentColor"
      />
      <path
        d="M3.4165 15.3334C4.383 15.3334 5.1665 14.5499 5.1665 13.5834C5.1665 12.6169 4.383 11.8334 3.4165 11.8334C2.45001 11.8334 1.6665 12.6169 1.6665 13.5834C1.6665 14.5499 2.45001 15.3334 3.4165 15.3334Z"
        fill="currentColor"
      />
    </svg>
  )
}
